import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-health-insurance.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetHealthInsuranceDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metHealthInsuranceEntity = useAppSelector(state => state.metHealthInsurance.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metHealthInsuranceDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.detail.title">MetHealthInsurance</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.code">Code</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.name">Name</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.status">Status</Translate>
            </span>
          </dt>
          <dd>{metHealthInsuranceEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-health-insurance" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-health-insurance/${metHealthInsuranceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetHealthInsuranceDetail;
